enum BiteLogAdyenEvent {
  TerminalDisconnected = 5,
}

export { BiteLogAdyenEvent };
